import { render, staticRenderFns } from "./sortImageText.vue?vue&type=template&id=6c8c397d&"
import script from "./sortImageText.vue?vue&type=script&lang=ts&"
export * from "./sortImageText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports